import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { queryClient } from '@/lib/query/query-client';

/**
 * Wrap l'app avec le `QueryClientProvider` de TanStack Query.
 *
 * @remarks
 * Toutes les `useQuery` / `useMutation` du projet en dépendent. À placer
 * haut dans l'arbre, juste sous le router root.
 */
export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
